module.exports = __webpack_public_path__ + "img/casa_de_bolos.efcdf456.svg";